import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import dayjs from 'dayjs';
import 'dayjs/locale/it';
import 'dayjs/locale/en';
import 'dayjs/locale/es';
import 'dayjs/locale/fr';
import 'dayjs/locale/de';
// ... altri locali che ti servono

type LocaleContextType = {
    locale: string;
    setLocale: (locale: string) => void;
};

const LocaleContext = createContext<LocaleContextType | undefined>(undefined);

type LocaleProviderProps = {
    children: ReactNode;
};

export const LocaleProvider: React.FC<LocaleProviderProps> = ({ children }) => {
    // Prendi il locale dalle preferenze utente, altrimenti usa quello del browser
    const [locale, setLocale] = useState<string>(() => {
        const userLocale = localStorage.getItem('userLocale');
        return userLocale || navigator.language.split('-')[0] || 'en';
    });

    useEffect(() => {
        dayjs.locale(locale);
        localStorage.setItem('userLocale', locale);
    }, [locale]);

    return (
        <LocaleContext.Provider value={{ locale, setLocale }}>
            {children}
        </LocaleContext.Provider>
    );
};

export const useLocale = (): LocaleContextType => {
    const context = useContext(LocaleContext);
    if (context === undefined) {
        throw new Error('useLocale must be used within a LocaleProvider');
    }
    return context;
};